import Drawer from '@/views/components/Modals/Drawer';
import Form from 'antd/lib/form/Form';
import PrimaryLabel from '../../../components/Labels/PrimaryLabel';

const TrailerDrawer = ({ openTrailerDrawer, closeTrailerDrawer, trailerForm, drawerHeader, submitForm, children }) => {
  return (
    <Drawer
      width="40%"
      open={openTrailerDrawer}
      headerContents={<PrimaryLabel className="text-white">{drawerHeader}</PrimaryLabel>}
      onClose={closeTrailerDrawer}
    >
      <div className="popup-body p-10">
        <Form form={trailerForm} onFinish={submitForm}>
          {children}
        </Form>
      </div>
    </Drawer>
  );
};

export default TrailerDrawer;
